import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Chip,
  List,
  ListItem,
  ListItemText,
  Divider,
} from "@mui/material";

const ViewCountryRequirementsDialog = ({ open, onClose, requirements, documentTypeName }) => {
  // Debug logging removed - functionality is working correctly

  const getAsteriskDescription = (specialRequirements) => {
    switch (specialRequirements) {
      case "1":
        return "Optional legalization";
      case "2":
        return "Required legalization";
      case "3":
        return "Required legalization + required sworn translation of CoC documents";
      case "4":
        return "Required sworn translation of CoC documents";
      default:
        return "No special requirement";
    }
  };

  const formatRequirement = (req) => {
    const countryName = req.country?.countryName || req.countryName || `Country ID: ${req.countryId}`;

    // Handle both old and new field names for backward compatibility
    // Check multiple possible field names and values
    let hasTimeRestriction = false;

    if (req.HasTimRestriction !== undefined) {
      // Backend field name (HasTimRestriction)
      hasTimeRestriction = Boolean(req.HasTimRestriction);
    } else if (req.hasTimeRestriction !== undefined) {
      // Frontend field name (hasTimeRestriction)
      hasTimeRestriction = Boolean(req.hasTimeRestriction);
    } else if (req.requirementType !== undefined) {
      // Old string field (requirementType)
      hasTimeRestriction = req.requirementType === "hasTimeRestriction";
    } else if (req.hasTimRestriction !== undefined) {
      // Check for camelCase version
      hasTimeRestriction = Boolean(req.hasTimRestriction);
    } else if (req.HasTimeRestriction !== undefined) {
      // Check for correct spelling
      hasTimeRestriction = Boolean(req.HasTimeRestriction);
    } else if (req.timeRestriction !== undefined) {
      // Check for other variations
      hasTimeRestriction = Boolean(req.timeRestriction);
    } else if (req.TimeRestriction !== undefined) {
      // Check for other variations
      hasTimeRestriction = Boolean(req.TimeRestriction);
    }

    const specialReq = req.specialRequirements;

    return {
      countryName,
      hasTimeRestriction,
      specialReq,
      specialReqDesc: specialReq ? getAsteriskDescription(specialReq) : null,
    };
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Country Requirements for "{documentTypeName}"</DialogTitle>
      <DialogContent>
        {requirements && requirements.length > 0 ? (
          <List>
            {requirements.map((req, index) => {
              const formatted = formatRequirement(req);

              return (
                <React.Fragment key={req.id || index}>
                  <ListItem sx={{ flexDirection: "column", alignItems: "flex-start" }}>
                    <Box sx={{ width: "100%", mb: 1 }}>
                      <Typography variant="h6" color="primary">
                        {formatted.countryName}
                      </Typography>
                    </Box>
                    <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                      {formatted.hasTimeRestriction && (
                        <Chip label="Time Restriction" color="warning" variant="outlined" size="small" />
                      )}
                      {formatted.specialReq && formatted.specialReq !== "" && (
                        <Chip label={formatted.specialReqDesc} color="info" variant="outlined" size="small" />
                      )}
                      {!formatted.hasTimeRestriction && !formatted.specialReq && (
                        <Chip label="No special requirements" color="default" variant="outlined" size="small" />
                      )}
                    </Box>
                  </ListItem>
                  {index < requirements.length - 1 && <Divider />}
                </React.Fragment>
              );
            })}
          </List>
        ) : (
          <Box sx={{ textAlign: "center", py: 3 }}>
            <Typography variant="body1" color="text.secondary">
              No country-specific requirements configured for this document type.
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewCountryRequirementsDialog;
